import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { StarIcon } from '@/components/icons/StarIcon';
import { cn } from '@/lib/cn';
export interface StarRatingProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  value?: number;
  max?: number;
}
export function StarRating(t0) {
  const $ = _c(17);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      value: t1,
      max: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const value = t1 === undefined ? 5 : t1;
  const max = t2 === undefined ? 5 : t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("flex gap-0.5 md:gap-0.75 items-center", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `Rated ${value} out of ${max}`;
  let t5;
  if ($[7] !== max) {
    t5 = [...Array(max)];
    $[7] = max;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5 || $[10] !== value) {
    t6 = t5.map((_, index) => <StarIcon filled={index < value} key={`${index}`} />);
    $[9] = t5;
    $[10] = value;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <div className={t3} {...props} aria-label={t4} role="img">{t6}</div>;
    $[12] = props;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}